import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { routerTransition } from "projects/backoffice/src/app/shared/animations/router.animations";
import { OfferBundleCheckoutRequirementListData } from "./models/offer-bundle-checkout-requirement-list-data.model";
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: "ifb-offer-bundle-checkout-requirement-list",
    templateUrl: "./offer-bundle-checkout-requirement-list.component.html",
    styleUrls: ["./offer-bundle-checkout-requirement-list.component.scss"],
    animations: routerTransition,
    standalone: false
})
export class OfferBundleCheckoutRequirementListComponent implements OnInit {

  tableColumns: string[] = [
    "name",
    "status",
    "requiredDocument",
    "isCreditModel",
    "isManual",
    "isFileUploaded",
    "uniqueId",
  ];

  constructor(
    private route: ActivatedRoute
  ) { }

  data: OfferBundleCheckoutRequirementListData;

  ngOnInit() {
    this.route.data
      .pipe(untilDestroyed(this))
      .subscribe((data: OfferBundleCheckoutRequirementListData) => {
        this.data = data;
      });
  }
}
